import { Timestamp } from "firebase/firestore";

const dateFormat = { year: 'numeric', month: '2-digit', day: '2-digit' };
const timeFormat = { hour: "2-digit", minute: "2-digit" };

export function timestampToDate(timestamp, offset=0) {
    let date = timestamp.toDate();
    date.setDate(date.getDate() + offset);
    return date.toLocaleDateString('de-DE', dateFormat);
}

export function timestampToDateTime(timestamp, offset=0) {
    let date = timestamp.toDate();
    date.setDate(date.getDate() + offset);
    return date.toLocaleDateString('de-DE', dateFormat) + ", " + date.toLocaleTimeString('de-DE', timeFormat);
}

export function displayDate(date, offset=0) {
    date.setDate(date.getDate() + offset);
    return date.toLocaleDateString('de-DE', dateFormat);
}

export function displayDateTime(date, offset=0) {
    date.setDate(date.getDate() + offset);
    return date.toLocaleDateString('de-DE', dateFormat) + ", " + date.toLocaleTimeString('de-DE', timeFormat);
}

export function offsetDate(date, offset=0) {
    date.setDate(date.getDate() + offset);
    return date;
}

export function offsetTimestamp(timestamp, offset=0) {
    let date = timestamp.toDate();
    date.setDate(date.getDate() + offset);
    return Timestamp.fromDate(date);
}

const dayInMillis = 24 * 60 * 60 * 1000;
export function daysBetweenDates(dateA, dateB) {
    return Math.round(Math.abs((dateB - dateA) / dayInMillis));
}

export function intToEuro(int) {
    const euro = int/100
    return euro.toLocaleString('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2});
}

export function intToCredits(int) {
    return isNaN(int) ? "Undefinierte Credits" : int > 1? int + " Credits": int + " Credit"
}